import requestMaker from './NetworkHandler';

export default requestMaker;
